var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.elementClass},[_c('span',{ref:"field",class:{ activate: this.isActive },staticStyle:{"display":"inline-table"},on:{"click":_vm.activate}},[_vm._t("default")],2),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],ref:"child",class:_vm.dropdownClass,style:({
      position: 'fixed',
      top: _vm.y + 'px',
      left: _vm.fromRight ? 'auto' : _vm.x + 'px',
      right: _vm.fromRight ? _vm.x + 'px' : 'auto',
      'z-index': 100,
      display: 'table',
    })},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }